import DeviceDetailsContainer from '../../../../components/units/Management/Device/details/deviceDetailsContainer';

export default function DeviceDetailsPage() {
  return <DeviceDetailsContainer />;
}
